import { forwardRef, SelectHTMLAttributes } from "react";
import styles from "./Form.module.css";
import { cx } from "../utils";

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

export const Select = forwardRef<HTMLSelectElement, SelectProps>(({ className, children, ...props }, ref) => (
    <select ref={ref} className={cx(styles.select, className)} {...props}>
        {children}
    </select>
));

Select.displayName = "Select";
